import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errMsg = (e, fallback = "Something went wrong") =>
  e?.response?.data?.detail
    ? typeof e.response.data.detail === "string"
      ? e.response.data.detail
      : "Invalid settings. Please check the values."
    : e?.message === "Network Error"
      ? "Cannot reach the server. Check your connection and retry."
      : fallback;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);

export const uploadImage = (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  return axios
    .post(`${API}/uploads`, fd, {
      onUploadProgress: (ev) => ev.total && onProgress?.(Math.round((ev.loaded / ev.total) * 100)),
    })
    .then((r) => r.data);
};

export const uploadImageUrl = (id) => `${API}/uploads/${id}/image`;
export const meshUrl = (id) => `${API}/models/${id}/mesh.stl`;
export const downloadUrl = (id, fmt) => `${API}/models/${id}/download?format=${fmt}`;

export const createRelief = (upload_id, params) =>
  axios.post(`${API}/relief`, { upload_id, params }).then((r) => r.data);
export const getModel = (id) => axios.get(`${API}/models/${id}`).then((r) => r.data);
export const transformModel = (id, body) =>
  axios.post(`${API}/models/${id}/transform`, body).then((r) => r.data);
export const createAiJob = (upload_id, target_size_mm) =>
  axios.post(`${API}/ai/jobs`, { upload_id, target_size_mm }).then((r) => r.data);
export const getAiJob = (id) => axios.get(`${API}/ai/jobs/${id}`).then((r) => r.data);

const KEY = "image2stl_projects";
export const listProjects = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
export const saveProject = (p) =>
  localStorage.setItem(KEY, JSON.stringify([p, ...listProjects().filter((x) => x.model_id !== p.model_id)].slice(0, 30)));
export const removeProject = (id) =>
  localStorage.setItem(KEY, JSON.stringify(listProjects().filter((x) => x.model_id !== id)));
